import { LayoutWithSubNav } from '@components/Layout/Layout';
import { navId } from '@containers/Billing/BillingSubNav';

export const BillingLayout = () => LayoutWithSubNav({ navId });
